<app-site-widget
	title="Site Battery Aging"
	elementId="batt_site_battery_aging"
	chartType="column"
	widgetClass="height-600"
	[widgetOptions]="{}"
	[data]="data"
	[config]="config"
	[tableColumns]="tableColumns"
	[siteId]="siteId"
	[customerId]="customerId"
	[customerName]="customerName"
	[siteName]="siteName"
></app-site-widget>